<template>
    <div :class="className" id="download-files">
        <section class="download">
            <li v-for="(file, key) in data.files" :key="key">
                <a
                    :href="file.file"
                    target=_blank
                    @click="$ga.event('files', 'download', file.name)"
                >{{ file.name }}</a>
            </li>
        </section>
    </div>
</template>

<script>
import DownloadFile from '@/components/DownloadFile.vue'
export default {
    components: {
        'download-file': DownloadFile
    }
}
</script>

<style scoped lang="sass">
@import "@/styles/framework/variables.sass"
@import "@/styles/framework/extends.sass"
.flex-download-files
    padding: 0
    background-color: $grey5
.download
    background-color: #fff
    padding: 40px 20px
    li
        list-style-type: none
        display: flex
        justify-content: center
        a
            text-align: center
            background-color: #1A2C70
            color: #FFFFFF
            font-size: 16px
            text-transform: uppercase
            font-weight: bold
            padding: 20px 26px
            transition: background-color .3s ease-in-out
            &:hover
                background-color: #ee3ea9

</style>
